import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useStatusConfig = () => {
    const { t } = useTranslation();
    return useMemo(() => [
        {
            name: t("status"),
            key: "status",
        },
        {
            name: t("start-date"),
            key: "startDate",
        },
        {
            name: t("reason"),
            key: "reason",
        },
    ], [t]);
}
